import type { ReactNode } from "react";
import { SWRConfig } from "swr";
import { usePitstopConfiguration } from "./AppConfigurationContext";

export function SWRConfigContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { REVALIDATE_IF_STALE } = usePitstopConfiguration();
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        revalidateIfStale: REVALIDATE_IF_STALE !== "false",
        errorRetryCount: 5,
      }}
    >
      {children}
    </SWRConfig>
  );
}
